module.exports = new __parcel__URL__("HowTo.df1d555c.webp").toString();